import { CheckCircle, Close } from "@mui/icons-material";
import { Box, Dialog, DialogContent, IconButton } from "@mui/material";
import CustomText from "./CustomText";

const SuccessModal = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={design.Prop}
    >
      <DialogContent sx={design.Margin}>
        {/* Header */}
        <Box sx={design.BoxText}>
          <CustomText
            color="#FFFFFF"
            fontFamily="Plus Jakarta Sans"
            fontWeight={800}
            fontSize={18}
          >
            Solicitud enviada
          </CustomText>
          <Box flex={1} />
          <IconButton onClick={onClose} sx={design.Color}>
            <Close />
          </IconButton>
        </Box>
        {/* Body */}
        <Box sx={design.Conten}>
          <CheckCircle sx={design.Check} />
          <CustomText
            color="#123055"
            fontFamily="Plus Jakarta Sans"
            fontWeight={800}
            fontSize={24}
            sx={design.Custom}
          >
            ¡Todo listo!
          </CustomText>
          <CustomText
            color="#5B6472"
            fontFamily="Plus Jakarta Sans"
            fontSize={15}
            sx={design.Descript}
          >
            Tu solicitud de cita fue enviada correctamente. Uno de nuestros
            asesores se pondrá en contacto contigo para confirmar la
            disponibilidad del médico y agendar tu consulta.
          </CustomText>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;

const design = {
  Prop: {
    sx: {
      borderRadius: "28px",
      overflow: "hidden",
    },
  },
  Margin: { p: 0 },
  BoxText: {
    background: "linear-gradient(180deg,#123055 0%, #102948 100%)",
    color: "#FFFFFF",
    px: 3,
    py: 2,
    display: "flex",
    alignItems: "center",
  },
  Color: { color: "#FFFFFF" },
  Conten: {
    px: 4,
    py: 5,
    textAlign: "center",
  },
  Check: {
    fontSize: 72,
    color: "#2D9BB3",
    mb: 2,
  },
  Custom: { mb: 1 },
  Descript: { lineHeight: 1.7, mb: 4 },
};
